import { DefaultUiFlagsStore, UiFlagsStore } from "./uiFlagsStore";
import { DefaultUserStore, UserStore } from "./userStore";
import { DefaultCalculateStore, CalculateStore } from "./calculateStore";
import { DefaultClientStore, ClientStore } from "./clientStore";
import { DefaultEstate } from "../helpers/estate";
import { Steps } from "../helpers/step";
import { Environments } from "../helpers/envinonment";
import { DefaultPolicyStore, PolicyStore } from "./policyStore";
import { AdditionalQuestionsId } from "../helpers/additionalQuestions/additionalQuestions";
import { DefaultClient } from "../helpers/client";
import { DefaultProposalStore, ProposalStore } from "./proposalStore";
import { Package } from "../helpers/package";
import { TypeOfActivityId } from "../helpers/additionalQuestions/typeOfActivity";
import { DefaultPartOfFarm } from "../helpers/additionalQuestions/partOfFarm";
import {
  DefaultNumberOfDamagesInLastThreeYears,
  NumberOfDamagesInLastThreeYearsId
} from "../helpers/additionalQuestions/numberOfDamagesInLastThreeYears";
import { DefaultPaymentMode, PaymentModeId } from "../helpers/additionalQuestions/paymentMode";
import { BusinessActivityId, DefaultBusinessActivityInBuilding } from "../helpers/additionalQuestions/businessActivity";
import { ClaimlessYearsId, DefaultClaimlessYearsIn5Years } from "../helpers/additionalQuestions/claimlessYearsIn5Years";
import { DefaultAdditionalProtections } from "../helpers/additionalQuestions/additionalProtections";
import { DefaultPolicyDuration, PolicyDurationId } from "../helpers/additionalQuestions/policyDuration";
import { addDays } from "date-fns";
import { CalculationService, DefaultCalculationService } from "../services/services/calculationService";
import { DefaultWidgetApiService, WidgetApiService } from "../services/services/widgetApiService";
import {
  CalculationRequestMapperForStore,
  DefaultStoreCalculationService,
  StoreCalculationService
} from "../services/services/storeCalculationService";
import {
  DefaultRetrieveCalculationService,
  RetrieveCalculationService
} from "../services/services/retrieveCalculationService";
import { DefaultProposalRequestMapper, ProposalRequestMapper } from "../services/services/proposalRequestMapper";
import { DefaultCalculationRequestMapper } from "../services/services/calculationRequestMapper";
import { DefaultRisksNetworkRequestMapper } from "../services/services/risksNetworkRequestMapper";
import { DefaultCalculationResponseMapper } from "../services/services/calculationResponseMapper";
import { RisksId } from "../helpers/risk";
import { RisksNetworkTypes } from "../helpers/risksNetwork";
import { DefaultDocumentStore, DocumentStore } from "./documentStore";
import { HogaService, DefaultHogaService } from "../services/services/hogaService";
import hogaApi from "../services/services/api/hogaApi";
import { DictionariesStore, DefaultDictionariesStore } from "./dictionariesStore";
import { DictionariesService, DefaultDictionariesService } from "../services/services/dictionariesService";
import { DefaultPolicyService, PolicyService } from "../services/services/policyService";
import { ProposalService, DefaultProposalService } from "../services/services/proposalService";
import { DocumentService, DefaultDocumentService } from "../services/services/documentService";
import widgetApi from "../services/services/api/widgetApi";
import { ClientEndsService, DefaultClientEndsService } from "../services/services/clientEndsService";
import { DefaultReplenishmentHistoryStore, ReplenishmentHistoryStore } from "./replenishmentHistoryStore";
import {DefaultRemotePaymentLinkService, RemotePaymentLinkService} from "../services/services/remotePaymentLinkService";
import {DefaultUwRulesService, UwRulesService} from "../services/services/sendforapproval";

export interface Stores {
  uiFlagsStore: UiFlagsStore;
  userStore: UserStore;
  calculateStore: CalculateStore;
  clientStore: ClientStore;
  policyStore: PolicyStore;
  proposalStore: ProposalStore;
  documentStore: DocumentStore;
  dictionariesStore: DictionariesStore;

  widgetApiService: WidgetApiService;
  hogaService: HogaService;
  calculationService: CalculationService;
  proposalService: ProposalService;
  storeCalculationService: StoreCalculationService;
  retrieveCalculationService: RetrieveCalculationService;
  dictionariesService: DictionariesService;
  policyService: PolicyService;
  documentService: DocumentService;
  clientEndsService: ClientEndsService;

  proposalRequestMapper: ProposalRequestMapper;
  replenishmentHistoryStore: ReplenishmentHistoryStore;
}

export class DefaultStores implements Stores {
  uiFlagsStore: UiFlagsStore;
  userStore: UserStore;
  calculateStore: CalculateStore;
  clientStore: ClientStore;
  policyStore: PolicyStore;
  proposalStore: ProposalStore;
  documentStore: DocumentStore;
  dictionariesStore: DictionariesStore;
  replenishmentHistoryStore: ReplenishmentHistoryStore;

  widgetApiService: WidgetApiService;
  hogaService: HogaService;
  calculationService: CalculationService;
  proposalService: ProposalService;
  storeCalculationService: StoreCalculationService;
  retrieveCalculationService: RetrieveCalculationService;
  dictionariesService: DictionariesService;
  policyService: PolicyService;
  documentService: DocumentService;
  clientEndsService: ClientEndsService;
  remotePaymentLinkService: RemotePaymentLinkService;
  uwRulesService: UwRulesService;

  proposalRequestMapper: ProposalRequestMapper;


  constructor() {
    this.uiFlagsStore = new DefaultUiFlagsStore();
    this.userStore = new DefaultUserStore();
    this.policyStore = new DefaultPolicyStore();
    this.calculateStore = new DefaultCalculateStore(this.policyStore);
    this.clientStore = new DefaultClientStore();
    this.proposalStore = new DefaultProposalStore();
    this.documentStore = new DefaultDocumentStore();
    this.dictionariesStore = new DefaultDictionariesStore();
    this.replenishmentHistoryStore = new DefaultReplenishmentHistoryStore();
    this.proposalRequestMapper = new DefaultProposalRequestMapper(this.calculateStore, this.clientStore,
      this.proposalStore, this.userStore, this.uiFlagsStore);

    const calculationRequestMapper = new DefaultCalculationRequestMapper(this.calculateStore, this.clientStore,
      this.policyStore, this.uiFlagsStore);
    const calculationRequestMapperForStore = new CalculationRequestMapperForStore(this.calculateStore,
      this.clientStore, this.policyStore, this.uiFlagsStore);
    const risksNetworkRequestMapper = new DefaultRisksNetworkRequestMapper(this.calculateStore, this.clientStore, this.policyStore, this.uiFlagsStore);
    const calculationResponseMapper = new DefaultCalculationResponseMapper(this.calculateStore);

    this.widgetApiService = new DefaultWidgetApiService(widgetApi, this.uiFlagsStore);
    this.hogaService = new DefaultHogaService(hogaApi, this.uiFlagsStore);
    this.calculationService = new DefaultCalculationService(this.calculateStore,
      this.widgetApiService, calculationRequestMapper, risksNetworkRequestMapper, calculationResponseMapper, this.replenishmentHistoryStore);
    this.proposalService = new DefaultProposalService(this.proposalStore, this.widgetApiService, this.proposalRequestMapper);
    this.storeCalculationService = new DefaultStoreCalculationService(this.widgetApiService,
      calculationRequestMapperForStore, this.calculateStore, this.proposalRequestMapper);
    this.retrieveCalculationService = new DefaultRetrieveCalculationService(this.widgetApiService,
      this.calculateStore, this.proposalStore, this.clientStore, this.policyStore, this.userStore, this.dictionariesStore, this.replenishmentHistoryStore, this.uiFlagsStore);
    this.dictionariesService = new DefaultDictionariesService(this.dictionariesStore, this.widgetApiService);
    this.policyService = new DefaultPolicyService(this.policyStore, this.widgetApiService);
    this.documentService = new DefaultDocumentService(this.widgetApiService, this.documentStore, this.policyStore);
    this.clientEndsService = new DefaultClientEndsService(this.clientStore, this.widgetApiService);
    this.remotePaymentLinkService= new DefaultRemotePaymentLinkService(this.clientStore, this.widgetApiService);
    this.uwRulesService= new DefaultUwRulesService(this.clientStore, this.widgetApiService);
  }
}

export const stores: Stores = new DefaultStores();

declare var window: any;
window.__APP_STATE__ = stores;

window.debug = {};
window.debug.loadExampleValue = (step?: Steps) => {
  if (stores.uiFlagsStore.environment === Environments.prod) {
    return;
  }

  function loadApkData() {
    stores.calculateStore.setApkOnlyNnw(false);
  }

  function loadQuestionToOfferData() {
    stores.calculateStore.setEstate(DefaultEstate.example());
    stores.calculateStore.resetPackages();
  }

  function loadOfferCustomizerData() {
    const additionalQuestions = {
      [AdditionalQuestionsId.typeOfActivity]: TypeOfActivityId.registered,
      [AdditionalQuestionsId.partOfFarm]: new DefaultPartOfFarm(false),
      [AdditionalQuestionsId.numberOfDamagesInLastThreeYears]: new DefaultNumberOfDamagesInLastThreeYears(NumberOfDamagesInLastThreeYearsId.zero),
      [AdditionalQuestionsId.paymentMode]: new DefaultPaymentMode(PaymentModeId.oneTime),
      [AdditionalQuestionsId.businessActivityInBuilding]: new DefaultBusinessActivityInBuilding(BusinessActivityId.no),
      [AdditionalQuestionsId.claimlessYearsIn5Years]: new DefaultClaimlessYearsIn5Years(ClaimlessYearsId.zero),
      [AdditionalQuestionsId.additionalProtections]: DefaultAdditionalProtections,
      [AdditionalQuestionsId.policyDuration]: new DefaultPolicyDuration(PolicyDurationId.MONTHS_12),
      [AdditionalQuestionsId.startDate]: addDays(new Date(), 1)
    };

    stores.calculateStore.setAdditionalQuestions(additionalQuestions);

    stores.clientStore.setClients([
      DefaultClient.example({
        pesel: "86072574337",
        firstName: "Jan",
        lastName: "Kowalski",
        insurer: true,
        insured: true,
        id: 0
      }),
      DefaultClient.example({
        pesel: "86042485263",
        firstName: "Janina",
        lastName: "Kowalska",
        insurer: false,
        insured: true,
        id: 1
      })]);

  }

  function loadContractData() {
    stores.proposalStore.distancePolicy.setValue(false);
    stores.calculateStore.setEstate(DefaultEstate.example());
    if (stores.calculateStore.packages.size !== 3) {
      stores.calculateStore.setPackages(new Package(stores.calculateStore.estate.propertyType!).allPackages);
    }

    stores.calculateStore.setAdditionalInsuranceFieldChecked(RisksId.secondOpinion, true);
    stores.calculateStore.additionalInsurances.secondOpinion.risksNetworkValue = RisksNetworkTypes.required;

    stores.proposalStore.setRequireConsents(true, stores.calculateStore, true);
    stores.proposalStore.setAllRequiredConsentsCheckbox(true);
    stores.proposalStore.setIssuePlace("Toruń");
  }

  switch (stores.uiFlagsStore.activeStep) {
    case Steps.apk:
      loadApkData();
      break;
    case Steps.questionsToOffer:
      loadQuestionToOfferData();
      break;
    case Steps.offerCustomizer:
      loadOfferCustomizerData();
      break;
    case Steps.contractData:
      loadContractData();
      break;
  }

  if (step) {
    switch (step) {
      case Steps.apk:
        loadApkData();
        break;
      case Steps.questionsToOffer:
        loadApkData();
        loadQuestionToOfferData();
        break;
      case Steps.offerCustomizer:
        loadApkData();
        loadQuestionToOfferData();
        loadOfferCustomizerData();
        break;
      case Steps.contractData:
        loadApkData();
        loadQuestionToOfferData();
        loadOfferCustomizerData();
        loadContractData();
        break;
    }

    stores.uiFlagsStore.setActiveStep(step);
  }
};
